import React, { useEffect } from 'react';
import { NavLink } from 'react-router-dom';
import { useSelector } from 'react-redux';
import logo from '../../assets/images/logo.png';
import logoSmall from '../../assets/images/logo-small.png';

import '../../styles/header.css';
import userPlaceholder from '../../assets/images/user-placeholder.png';

const Header = ({ sidebarOpen, toggleSidebar }) => {
    // Redux state
    const user = useSelector((state) => state.auth.user);

    // Handle sidebar toggle effects
    useEffect(() => {
        const fixedEl = document.querySelector('.fixedElements')?.classList;
        const mainH = document.querySelector('.main-header')?.classList;
        const mainS = document.querySelector('.main-sidebar')?.classList;

        if (fixedEl && mainH && mainS) {
            if (!sidebarOpen) {
                fixedEl.add('expandView');
                mainH.add('header-expand');
                mainS.add('sidebar-shrink');
            } else {
                fixedEl.remove('expandView');
                mainH.remove('header-expand');
                mainS.remove('sidebar-shrink');
            }
        }
    }, [sidebarOpen]);

    // Don't render if no user
    if (!user) {
        return null;
    }

    return (
        <header className='main-header'>
            <nav className='navbar navbar-static-top'>
                <div className='search-sidebar-toggle'>
                    <a className='sidebar-toggle' onClick={toggleSidebar} role='button'>
                        <span className='sr-only'>Toggle navigation</span>
                    </a>
                </div>

                <div className='navbar-custom-menu'>
                    <ul className='nav navbar-nav'>
                        <li className='dropdown user user-menu'>
                            <a href='#' >
                                <img src={userPlaceholder} className='user-image' alt='User Image' />
                                <span className='hidden-xs user-name'>{user.name || user.email}</span>
                            </a>
                            <ul className='dropdown-menu'>
                                <li className='user-header'>
                                    <img src='dist/img/user2-160x160.jpg' className='img-circle' alt='User Image' />
                                </li>
                                <li className='user-footer'>
                                    <div className='pull-left'>
                                        <a href='#' className='btn btn-default btn-flat'>
                                            Profile
                                        </a>
                                    </div>
                                    <div className='pull-right'>
                                        <a href='#' className='btn btn-default btn-flat'>
                                            Sign out
                                        </a>
                                    </div>
                                </li>
                            </ul>
                        </li>
                    </ul>
                </div>
            </nav>
        </header>
    );
};

export default Header;
